/**
 * Gli strumenti di prova (notifiche di test, …) si mostrano solo in sviluppo
 * locale (INB-371): prima erano visibili a tutti, anche sul sito pubblicato.
 * La build del web (`bun build`) non espone un flag di sviluppo, quindi si
 * guarda l'host: il sito pubblicato non gira mai su localhost.
 */
export function devToolsEnabled(): boolean {
	return (
		typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname)
	);
}
